import CoreIndex from 'core/js/pages/municipality-data/balance/tsc/_tsc_media_panel/index.js'
import Transaction from './_transaction'

export default {
  extends: CoreIndex,
  components: {
    ...CoreIndex.components,
    Transaction
  }
}